var Handlebars = require("/home/admin/gitlab_code/assets/enhancer/user-center-assets/node_modules/handlebars/runtime.js");
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"login-title\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.login : stack1), depth0))
    + "</div>\n<div class=\"login-form\">\n  <div class=\"form-item\">\n    <input id=\"account\" class=\"enhancer-input\" data-type=\"email\" type=\"text\" name=\"account\" placeholder=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.mobileOrEmail : stack1), depth0))
    + "\">\n    <label for=\"account\"></label>\n  </div>\n  <div class=\"form-item\">\n    <input id=\"password\" class=\"enhancer-input\" data-type=\"password\" type=\"password\"  name=\"password\" placeholder=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.password : stack1), depth0))
    + "\">\n    <label for=\"password\"></label>\n  </div>\n  <div class=\"form-item\">\n    <div id=\"captcha\" style=\"margin-left: 40px;\" />\n    <label for=\"captcha\"></label>\n  </div>\n  <div class=\"form-item\">\n    <button class=\"enhancer-btn\" type=\"submit\">\n      "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.login : stack1), depth0))
    + "\n      <i class=\"far fa-arrow-alt-circle-right\"></i>\n    </button>\n  </div>\n  <div class=\"form-item register\">\n    <a href=\""
    + alias2(alias1((depth0 != null ? depth0.domain0 : depth0), depth0))
    + "/forget\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.forgetPassword : stack1), depth0))
    + "</a>\n    <span class=\"switch-lang fas fa-language\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.switchLang : stack1), depth0))
    + "</span>\n    <a href=\""
    + alias2(alias1((depth0 != null ? depth0.domain0 : depth0), depth0))
    + "/register\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.register : stack1), depth0))
    + "</a>\n  </div>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/pages/login/login.html
// module id = 6
// module chunks = 0